import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio']

  uncheck () {
    if (!this.hasRadioTarget) return

    this.radioTargets.forEach(radio => {
      radio.checked = false
      radio.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
